import React from 'react'

const IconsMobileNew = (props) => {
    return (
        <svg
            width='20'
            height='20'
            viewBox='0 0 16 16'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
            className='icons-icon'
            {...props}
        >
            <path
                d='M11.333 1.3335H4.66634C3.92996 1.3335 3.33301 1.93045 3.33301 2.66683V13.3335C3.33301 14.0699 3.92996 14.6668 4.66634 14.6668H11.333C12.0694 14.6668 12.6663 14.0699 12.6663 13.3335V2.66683C12.6663 1.93045 12.0694 1.3335 11.333 1.3335Z'
                stroke='currentColor'
                strokeWidth='1.25'
                strokeLinecap='round'
                strokeLinejoin='round'
            />
            <path
                d='M8 12H8.00667'
                stroke='currentColor'
                strokeWidth='1.25'
                strokeLinecap='round'
                strokeLinejoin='round'
            />
        </svg>
    )
}

export default IconsMobileNew
